import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Layout from "../components/Layout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { api } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("admin_token", data.token);
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <Layout>
      <section className="max-w-md mx-auto px-4 py-20">
        <h1 className="text-3xl font-serif text-slate-900">Clinic sign in</h1>
        <p className="mt-2 text-slate-600 text-sm">For Dr. Porwal and clinic staff only.</p>
        <form onSubmit={submit} className="mt-8 bg-white border border-slate-200 rounded-2xl p-8 space-y-5" data-testid="admin-login-form">
          <div className="space-y-2"><Label>Email</Label><Input type="email" className="h-12" value={email} onChange={e => setEmail(e.target.value)} data-testid="admin-email-input" required /></div>
          <div className="space-y-2"><Label>Password</Label><Input type="password" className="h-12" value={password} onChange={e => setPassword(e.target.value)} data-testid="admin-password-input" required /></div>
          <Button type="submit" disabled={busy} className="w-full h-12 bg-teal-700 hover:bg-teal-800 text-white rounded-full" data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"}</Button>
        </form>
      </section>
    </Layout>
  );
}
